export default __webpack_public_path__ + "static/media/hero.e2fb54c7.png";